import React, { useState, useEffect, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {
    Modal,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tab,
    Tabs,
    Avatar,
    Box,
    Typography,
    Stack,
} from "@mui/material";

import Badge from "@mui/material/Badge";
import { styled } from "@mui/system";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import DataTable from "examples/Tables/DataTable";
import ServiceRequestDataTable from "examples/Tables/ServiceRequestDataTable";
import moment from "moment";
import CollapsibleTable from "examples/Tables/ExpandTable";
import Skeleton from "@mui/material/Skeleton";
import GoogleMapComponent from "examples/Maps";
import { useMediaQuery } from "react-responsive";
import breakpoints from "assets/theme/base/breakpoints";
import { renderIcon } from "utils/renderIcon";
import AssetTrackerMap from "examples/Maps/assetTrackerMap";
import { useMaterialUIController } from "context";
import RouteCollapsibleTabTable from "examples/Tables/RouteCollapseTable/RouteCollapsibleTabTable";
import RouteModal from "../view-device/RouteModel";
import JsonTree from "cruds/campaign/modal/jsontree";
import convertUtils from 'convert-units';
import { calculateDurations, getDuration, calculateGeofenceTimes, calculateFuelUsed } from "utils/utils";
import { gpsStatusBadgeColor, counter_data, show_current_data, formatDuration, show_device_signal_data, show_transmission_data } from "utils/constant";

const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
        textWrap: "unwrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "center",
        height: "auto",
        padding: "6px",
    },
}));

const StackSkeleton = () => {
    return (
        <Stack spacing={0.5}>
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
            <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
        </Stack>
    );
};

const PublicAssetTracker = ({ deviceId }) => {
    const navigate = useNavigate();
    const serviceRequestSelectedTab = localStorage.getItem("serviceRequestTab") ?? 0;

    const [name, setName] = useState({
        text: "",
        error: false,
        textError: "",
    });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    const [paramValues, setParamValues] = useState([]);
    const [paramValue, setParamValue] = useState();
    const [device, setDevice] = useState();
    const [tableData, setTableData] = useState([]);
    const [expandedIndexArray, setExpandedIndexArray] = useState([
        true,
        true,
        true,
        ...Array(6).fill(false),
    ]);
    const [selectedTab, setSelectedTab] = useState(
        parseInt(serviceRequestSelectedTab)
    );

    const [alerts, setAlerts] = useState([]);
    const [alertTableData, setAlertTableData] = useState([]);

    const [alertRules, setAlertRules] = useState([]);
    const [event, setEvent] = useState([]);
    const [eventTableData, setEventTableData] = useState([]);
    const [serviceRequests, setServiceRequests] = useState([]);
    const [alertRuleTableData, setAlertRuleTableData] = useState([]);
    const [serviceRequestTableData, setServiceRequestTableData] = useState([]);

    const [notification, setNotification] = useState({
        value: false,
        text: "",
    });

    const [pillbarColor, setPillbarColor] = useState("rgb(38, 40, 51);");
    const [activeAlerts, setActiveAlerts] = useState([]);
    const [loaderT, setLoaderT] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [gps, setGps] = useState({ latitude: "", longitude: "", edit: false });
    const [tabsOrientation, setTabsOrientation] = useState("horizontal");

    const [deviceSetupFields, setDeviceSetupFields] = useState({
        depth: "",
        shape: "",
        width: "",
        length: "",
        latitude: "",
        longitude: "",
    });
    const [navbarTitle, setNavbarTitle] = useState("");
    const [gpsStatus, setGpsStatus] = useState(0)
    const [gpsData, setGpsData] = useState({ latitude: null, longitude: null })
    const [parameters, setParameter] = useState([])
    const [mapIcon, setMapIcon] = useState(null)
    const [titleIcon, setTitleIcon] = useState(null)
    const [, dispatch] = useMaterialUIController();
    const [reporting, setReporting] = useState(null)
    const [routeData, setRouteData] = useState([]);
    const [routeAllData, setRouteAllData] = useState([]);
    const [reportType, setReportType] = useState({});
    const [templateValuesList, setTemplateValuesList] = useState([]);
    const [highlightRouteData, setHighlightRouteData] = useState([])
    const [icons, setIcons] = useState(null);
    const [selectedRouteGroup, setSelectedRouteGroup] = useState(null)
    const [openJsonTree, setJsonTree] = useState(false)
    const [rawDataValue, setRawDataValue] = useState({})
    const [ignoreHeading, setIgnoreHeading] = useState(null)
    const [geofence, setGeofence] = useState(null)
    const [geofenceIcon, setGeofenceIcon] = useState(null)
    const [trackingCounter, setTrackingCounter] = useState(null)
    const uiPage = useRef(null)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const countRef = useRef(0);

    useEffect(() => {
        if (!deviceId) return;
        (async () => {
            try {
                setParameter([])
                setGpsData(() => ({ latitude: null, longitude: null }));
                setLoader(true);

                const res = await CrudService.getPublicDeviceView(deviceId);

                setDevice(res?.data);
                let icons = res?.data?.attributes?.EntityAddressItem?.Icon
                setMapIcon(icons?.class_name)
                setTitleIcon(icons?.class_name)

                setName({ text: res.data.attributes?.name });
                setIgnoreHeading(res?.data?.attributes?.EntityAddressItem?.ignore_heading)
                let lastRecord;

                setParamValues(res?.data?.monitorParameterValues);
                lastRecord = res?.data?.monitorParameterValues[0];
                setReporting(res?.data?.latestWebhookData ? res?.data?.latestWebhookData[0]?.timestamp : null)
                setParamValue(lastRecord?.data);
                setGpsData(() => ({ latitude: lastRecord?.data.position_latitude ?? 0, longitude: lastRecord?.data?.position_longitude ?? 0 }))
                setParamValue(lastRecord?.data);
                setGpsData(() => ({ latitude: lastRecord?.data.position_latitude ?? 0, longitude: lastRecord?.data?.position_longitude ?? 0 }))
                setGpsStatus(lastRecord?.data?.moment_status)
                if (res?.data?.reportTypes) {
                    let obj = {};
                    for (let report of res?.data?.reportTypes) {
                        obj[report.report_type_identifier] = report.report_type_name;
                    }
                    setReportType(obj);
                }
                const isGeofenceExist = await CrudService.checkGeofenceExist({
                    lat: lastRecord?.data?.position_latitude,
                    lng: lastRecord?.data?.position_longitude,
                    entity_id: res?.data?.attributes?.EntityAddressItem?.entity_id,
                    device_id: Number(deviceId),
                    address_item_id: res?.data?.attributes?.EntityAddressItem?.address_item_id
                })

                if (isGeofenceExist?.success) {
                    setGeofenceIcon(isGeofenceExist.icons)
                    setGeofence(isGeofenceExist.data)
                }
                let route_utils = await CrudService.getRoutesUtils();
                setTemplateValuesList(route_utils.route_template_values)
                setIcons(route_utils?.icons)
                let today_routes = await CrudService.getTodayRoutes(deviceId);
                if (today_routes?.success) {
                    setRouteData(today_routes.data.length > 0 ? [today_routes.data[0]] : today_routes.data);
                }
                setLoader(false);

                // const alertRes = await CrudService.getDeviceAlerts(resp.device_id);
                setAlerts(res?.data?.alertsArray ?? []);

                // const eventRes = await CrudService.getDeviceEvent(resp.device_id);
                setEvent(res?.data?.events ?? []);

                // const alertRulesRes = await CrudService.getAlertRules({ id: resp.device_id });
                setAlertRules(res?.data?.alertRulesArray ?? []);

                // const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(resp.device_id);
                setActiveAlerts(res?.data?.deviceAlerts ?? []);

                const trackingRes = await CrudService.getTrackingCounter(deviceId);
                if (trackingRes.success) {
                    setTrackingCounter(trackingRes.data)
                }

                const deviceParameter = await CrudService.getDeviceParameter();
                setParameter(() => [...deviceParameter.data])

                setServiceRequests(res?.data?.serviceRequest ?? []);

                let deviceThresholds = res?.data?.deviceThresholds;
                for (let deviceThreshold of deviceThresholds) {
                    if ([1, 26].includes(deviceThreshold.threshold_type_id)) {
                        let color = "rgb(38, 40, 51);";
                        let comparison_operator_id = deviceThreshold.comparison_operator_id;
                        const parameterName =
                            deviceThreshold?.DeviceParameter?.parameter_name;

                        const parameterMapping = {
                            percent_level: "percent_level",
                            Temperature: "enclosure_temperature",
                            product_level: "inch_level",
                            measured_height: "measured_height",
                        };

                        const propertyKey = parameterMapping[parameterName];
                        const parameterValue = parseInt(
                            lastRecord?.data?.device_data?.[propertyKey]
                        );
                        const thresholdValue = parseInt(deviceThreshold.threshold_value);

                        if (propertyKey === undefined) {
                            // console.error(`Unknown parameter name: ${parameterName}`);
                            return;
                        }

                        switch (parseInt(comparison_operator_id)) {
                            case 1:
                                color =
                                    parameterValue === thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 2:
                                color =
                                    parameterValue !== thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 3:
                                color =
                                    parameterValue < thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 4:
                                color =
                                    parameterValue <= thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 5:
                                color =
                                    parameterValue > thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 6:
                                color =
                                    parameterValue >= thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            default:
                                color = "rgb(38, 40, 51);";
                                break;
                        }

                        setPillbarColor(color);
                    }
                }
            } catch (err) {
                if (err.status == 400) {
                    navigate("/user-profile");
                }
                console.error(err);
            }
        })();
    }, [deviceId]);

    useEffect(() => {
        (async () => {
            let all_routes = await CrudService.getRoutes(deviceId, page + 1, rowsPerPage);
            if (all_routes.success) {
                setRouteAllData(all_routes.data);
                countRef.current = all_routes.count
            }
        })()
    }, [page, rowsPerPage])

    useEffect(() => {
        setTableData(getRows(paramValues));
        if (paramValues.length) {
            setLoaderT(false);
        }
    }, [paramValues]);

    useEffect(() => {
        let filter = [];
        let alertFilter = getAlertRows(alerts);
        alertFilter.filter((value) => {
            filter.push(value);
            if (value.is_parent) {
                filter.push({ ...value, is_parent: false });
            }
        });
        setAlertTableData(filter);
    }, [alerts]);

    useEffect(() => {
        setAlertRuleTableData(getAlertRuleRows(alertRules));
    }, [alertRules]);

    useEffect(() => {
        setEventTableData(getEventRows(event));
    }, [event]);

    useEffect(() => {
        setServiceRequestTableData(getServiceRequestRows(serviceRequests));
    }, [serviceRequests]);

    useEffect(() => {
        if (notification.value === true) {
            let timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: "",
                });
            }, 5000);
        }
    }, [notification]);

    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 100) {
                setNavbarTitle(device?.attributes?.name || ""); // Set device name when scrolled down
            } else {
                setNavbarTitle(""); // Remove when scrolled up
            }
        }

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [device?.attributes?.name]);

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }

        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);

        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    function capitalizeWords(str) {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    }

    const deviceSignalSubHeaderStyle = {
        color: '#fff',
        margin: '5px 0'
    }

    const getRows = (info) => {
        // Sort info array by id in descending order
        info.sort((a, b) => b.id - a.id);

        let updatedInfo = info.map((row, index) => {
            return {
                id: row?.id,
                report_type: row?.data?.report_reason
                    ? reportType[row?.data?.report_reason] ?? ""
                    : "",
                latitude: row.data?.position_latitude ?? '',
                longitude: row.data?.position_longitude ?? '',
                speed: row.data?.convert_position_speed ?? '',
                direction: row.data?.position_direction ?? '',
                satellite_count: row.data?.position_satellites ?? '',
                external_power_status: row.data?.external_powersource_status ? 'True' : 'False',
                engine_ignition_status: row.data?.engine_ignition_status ? 'True' : 'False',
                date: row?.created_at,
            };
        });
        return updatedInfo;
    };

    const dataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            { Header: "Report Type", accessor: "report_type", show: true },
            {
                Header: "Latitude",
                accessor: "latitude",
            },
            {
                Header: "Longitude",
                accessor: "longitude",
            },
            {
                Header: "Speed",
                accessor: "speed",
            },
            {
                Header: "Direction",
                accessor: "direction",
            },
            {
                Header: "Satellite Count",
                accessor: "satellite_count",
            },
            {
                Header: "External Power Status",
                accessor: "external_power_status",
            },
            {
                Header: "Engine Ignition Status",
                accessor: "engine_ignition_status",
            },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.cell.row.original.date).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
        ],
        rows: tableData, // Assuming tableData is your original data array
    };

    const getAlertRuleRows = (info) => {
        let updatedInfo = info.map((row) => {
            let frequency = "";
            if (row.attributes?.frequency && row.attributes?.frequency != null) {
                frequency =
                    row.attributes?.frequency +
                    " min" +
                    (row.attributes?.frequency > 1 ? "(s)" : "");
            }

            let rule_type =
                row.attributes?.module_id === 12
                    ? "Alert"
                    : row.attributes?.module_id === 13
                        ? "Service Request"
                        : "";

            const event_type_id = row.attributes?.event_type_id;
            let message_template_name = "";
            if (event_type_id == 14) {
                message_template_name = row.attributes?.SendgridTemplate?.name;
            }
            if (event_type_id == 15) {
                message_template_name = row.attributes?.MessageTemplate?.name;
            }
            return {
                id: row?.id,
                rule_type: rule_type,
                alert_type: row.attributes?.AlertType?.type_name,
                alert_type_category: row.attributes?.AlertType?.category,
                alert_sub_type: row.attributes?.AlertSubType?.sub_type_name,
                event_type: row.attributes?.EventType?.name,
                message_template_name: message_template_name,
                address: row.attributes?.ContactAddress?.contact_address,
                send_to_type: row.attributes?.SendToType?.send_to_type_name,
                frequency: frequency,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });

        return updatedInfo;
    };

    const alertRuledataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            { Header: "Status Badge", accessor: "status", show: true },
            { Header: "Status ", accessor: "status_text", show: false },

            { Header: "Rule Type", accessor: "rule_type", show: true },
            { Header: "Alert Type", accessor: "alert_type", show: true },
            {
                Header: "Alert Type Category",
                accessor: "alert_type_category",
                show: true,
            },
            { Header: "Alert Sub Type", accessor: "alert_sub_type", show: true },
            { Header: "Event Type", accessor: "event_type", show: true },
            {
                Header: "Message Template Name",
                accessor: "message_template_name",
                show: true,
            },
            { Header: "Address", accessor: "address", show: true },
            { Header: "Send Type", accessor: "send_to_type", show: true },
            { Header: "Frequency", accessor: "frequency", show: true },
        ],
        rows: alertRuleTableData, // Assuming tableData is your original data array
    };

    const getEventRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row?.event_id,
                alert_type: row?.AlertType?.type_name,
                parameter_name: row?.DeviceParameter?.parameter_name,
                icon: row?.AlertType?.Icon ? row?.AlertType?.Icon?.class_name : '',
                percent_value: row?.percent_change,
                prev_value: row?.previous_value,
                current_value: row?.new_value,
                volume: row?.volume_change,
                date: row?.event_timestamp,
            };
        });

        return updatedInfo;
    };

    const eventdataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            {
                Header: "Type",
                accessor: "alert_type",
                show: true,
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center" style={{ color: '#ffffffcc', gap: '0.4rem' }}>
                            <i className={info.cell.row.original.icon} style={{ fontSize: "16px" }}></i> <h6 style={{ fontSize: '0.875rem' }}>{info.value}</h6>
                        </MDBox>
                    )
                }
            },
            { Header: "Parameter Name", accessor: "parameter_name", show: true },
            { Header: "Current Value", accessor: "current_value", show: true },
            { Header: "Previous Value", accessor: "prev_value", show: true },
            // {
            //     Header: "Percent Change",
            //     accessor: "percent_value",
            //     show: true,
            //     Cell: (info) => `${Number(info.value).toFixed(0)}%`,
            // },
            // {
            //     Header: "Volume Change ( Gallons )",
            //     accessor: "volume",
            //     show: true,
            //     Cell: (info) => `${Number(info.value).toFixed(0)}`,
            // },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.cell.row.original.date).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
        ],
        rows: eventTableData, // Assuming tableData is your original data array
    };

    const getServiceRequestRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row.attributes?.service_request_id,
                user: row.attributes?.user?.name,
                entityAddressItem: row.attributes?.EntityAddressItem?.name,
                provider: row.attributes?.Provider?.provider_name,
                serviceItem: row.attributes?.ServiceItem?.item_name,
                request_date: row.attributes?.request_date,
                status: row.attributes?.StatusOption,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
            };
        });

        return updatedInfo;
    };

    const serviceRequestdataTableData = {
        columns: [
            { Header: "ID", accessor: "id", width: "12rem", show: true },
            {
                Header: "Status Badge",
                accessor: "",
                width: "12rem",
                show: true,
                Cell: (info) => {
                    return (
                        <StyledBadge
                            color={
                                info.cell.row.original?.status?.BadgeDetail?.color || "primary"
                            }
                            variant={
                                info.cell.row.original?.status?.BadgeDetail?.variant ||
                                "contained"
                            }
                            badgeContent={
                                info.cell.row.original.status?.StatusType?.status_name
                            }
                            style={{ marginLeft: "30px" }}
                        ></StyledBadge>
                    );
                },
            },
            { Header: "Status", accessor: "status_text", width: "12rem", show: true },

            {
                Header: "Entity Address Item",
                accessor: "entityAddressItem",
                width: "12rem",
                show: true,
            },
            { Header: "Provider", accessor: "provider", width: "12rem", show: true },
            {
                Header: "Service Item",
                accessor: "serviceItem",
                width: "12rem",
                show: true,
            },
            {
                Header: "Requested Date",
                accessor: "request_date",
                width: "12rem",
                show: true,
            },
            { Header: "User", accessor: "user", width: "12rem", show: true },
        ],
        rows: serviceRequestTableData, // Assuming tableData is your original data array
    };

    const getAlertRows = (info) => {
        let updatedInfo = info.map((row) => {
            const createdAt = row.attributes.created_at
                ? moment(row.attributes.created_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const updatedAt = row.attributes.updated_at
                ? moment(row.attributes.updated_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const subType = row.attributes.is_parent
                ? "Alert Created"
                : row.attributes.is_healed
                    ? "Alert Healed"
                    : "Alert Resent";

            return {
                id: row.id,
                device_id: row.attributes?.device_id,
                alert_type_id: row.attributes?.alert_type_id,
                alert_type: row.attributes?.AlertType?.type_name,
                alert_type_category: row.attributes?.AlertType?.category,
                device: row.attributes.Device?.name,
                sub_type: subType,
                is_parent: row.attributes?.is_parent,
                created_at: createdAt,
                updated_at: updatedAt,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });
        return updatedInfo;
    };

    const alertColumns = [
        { Header: "ID", accessor: "id", width: "5%", show: true },
        { Header: "Status Badge", accessor: "status", width: "10%", show: true },
        { Header: "Status", accessor: "status_text", show: false },
        { Header: "Alert Type", accessor: "alert_type", width: "15%", show: true },
        {
            Header: "Alert Category",
            accessor: "alert_type_category",
            width: "5%",
            show: true,
        },
        { Header: "Sub Type", accessor: "sub_type", width: "15%", show: true },
        { Header: "Device", accessor: "device", width: "15%", show: true },
        { Header: "Created At", accessor: "created_at", width: "15%", show: true },
        { Header: "Updated At", accessor: "updated_at", width: "15%", show: true },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
        },
    ];

    const routeColumns = [
        { Header: "ID", accessor: "route_id", width: "5%", show: true },
        {
            Header: "Status", accessor: "status", width: "5%", show: true, Cell: (info, row) => {
                const badgeDetail = row.status_option.BadgeDetail
                return (
                    <Badge
                        color={badgeDetail.color}
                        variant={badgeDetail.variant}
                        badgeContent={info}
                        style={{ marginLeft: "20px" }}
                    ></Badge>
                )
            }
        },
        { Header: "Start Route", accessor: "start_time", width: "15%", show: true },
        { Header: "End Route", accessor: "end_time", width: "15%", show: true },
        { Header: "Visited Geofences", accessor: "visited_geofences", width: "10%", show: true },
        { Header: "Total Time(Geofences)", accessor: "total_time_in_geofences", width: "15%", show: true },
        { Header: "Total Distance", accessor: "total_distance", width: "10%", show: true },
        { Header: "Total Duration", accessor: "total_duration", width: "10%", show: true },
        { Header: "Run Time", accessor: "run_time", width: "10%", show: true },
        { Header: "Pause Time", accessor: "pause_time", width: "10%", show: true },
        { Header: "Fuel Used", accessor: "fuel_used", width: "10%", show: true },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
        },
    ];
    const routeSubColumns = [
        { Header: "ID", accessor: "point_id", show: true },
        { Header: "Status", accessor: "status", show: true },
        { Header: "Latitude", accessor: "latitude", show: true },
        { Header: "Longitude", accessor: "longitude", show: true },
        { Header: "Speed", accessor: "speed", show: true },
        {
            Header: "Heading",
            accessor: "heading",

            show: true,
        },
        { Header: "Geofence", accessor: "geofence_id", show: true },
        { Header: "Geofence Event", accessor: "geofence_event_id", show: true },
        { Header: "Ignition On", accessor: "ignition_on", show: true },
        { Header: "RPM", accessor: "can_engine_rpm", show: true },
        { Header: "Fuel Level", accessor: "can_fuel_level", show: true },
        { Header: "MAP", accessor: "convert_can_intake_map", show: true },
        { Header: "Engine Load", accessor: "can_engine_load_level", show: true },
        { Header: "Throttle Level", accessor: "can_throttle_pedal_level", show: true },
        { Header: "Intake Air Temp", accessor: "convert_can_intake_air_temperature", show: true },
        { Header: "Coolant Temp", accessor: "convert_can_engine_coolant_temperature", show: true },
        // { Header: "Vehicel vin", accessor: "vehicle_vin", show: true },
        { Header: "Place Location", accessor: "place_location", show: true },
        { Header: "Place Type", accessor: "place_type", show: true },
        { Header: "Timestamp", accessor: "timestamp", show: true },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
        },
    ];


    const getRouteTable = (info) => {
        let updatedInfo = info.map((row) => {

            if (row.start_group_id) {
                row['start_group'] = templateValuesList.filter((e) => e.condition_group_id == row.start_group_id)
            }
            if (row.end_group_id) {
                row['end_group'] = templateValuesList.filter((e) => e.condition_group_id == row.end_group_id)
            }

            let { pauseTime, runTime } = calculateDurations(row?.RouteTrackingPoints ?? [])
            let finalOutput = calculateGeofenceTimes(row?.RouteTrackingPoints ?? [])
            let fuelUsed = calculateFuelUsed(row?.RouteTrackingPoints ?? [])

            const formatted = Object.entries(finalOutput)
                .filter(([, values]) => values.duration !== 0)
                .map(([name, values]) => `${name}: ${values.readableDuration}`)
                .join(", ");

            const formattedNames = Object.entries(finalOutput)
                .filter(([, values]) => values.duration !== 0)
                .map(([name]) => name)
                .join(", ");


            return {
                ...row,
                route_id: row?.route_id,
                status: row?.StatusType?.status_name,
                start_log_id: row?.start_log_id ?? '',
                end_log_id: row?.end_log_id ?? '',
                device_id: row?.device_id,
                RouteTrackingPoints: row?.RouteTrackingPoints ?? [],
                start_time: row?.start_time ? moment(row?.start_time).format("MMMM DD, YYYY h:mm:ss A") : '',
                end_time: row?.end_latitude ? (row?.end_time ? moment(row?.end_time).format("MMMM DD, YYYY h:mm:ss A") : '') : '',
                start_latitude: row?.start_latitude ?? '',
                start_longitude: row?.start_longitude ?? '',
                end_latitude: row?.end_latitude ?? '',
                end_longitude: row?.end_longitude ?? '',
                total_distance: row?.total_distance ? `${convertUtils(row?.total_distance).from('km').to('mi').toFixed(2)} miles` : '',
                total_duration: row?.total_duration ? getDuration(row?.total_duration) : '',
                pause_time: pauseTime ? getDuration(pauseTime) : '',
                run_time: runTime ? getDuration(runTime) : '',
                visited_geofences: formattedNames ?? '',
                total_time_in_geofences: formatted ?? '',
                fuel_used: fuelUsed ?? ''
            };
        });

        return updatedInfo;
    }

    const handleExpand = (index) => {
        setExpandedIndexArray((prevArray) =>
            prevArray.map((item, idx) => (idx === index ? !item : item))
        );
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        localStorage.setItem("serviceRequestTab", newValue);
    };

    const renderTableCell = (data) => {
        // If the data is an object (JSON), render each key-value pair
        if (typeof data === "object" && data !== null) {
            return (
                <Table>
                    <TableBody>
                        {Object.entries(data).map(([key, value]) => (
                            <TableRow key={key}>
                                <TableCell sx={{ padding: "1px!important;" }}>
                                    {formatColumnName(key)}
                                </TableCell>
                                <TableCell sx={{ padding: "1px!important;" }}>
                                    {renderTableCell(value)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            );
        }
        return data;
    };

    const formatColumnName = (name) => {
        return name
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
    };

    const cardStyle = (index) => ({
        display: "flex",
        flexDirection: "column",
        ...(expandedIndexArray[index] && { minHeight: "100%" }),
    });

    const styles = {
        table: {
            padding: 0,
            borderSpacing: 0,
            borderCollapse: "collapse",
        },
        cell: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: isTabletOrMobile ? "0" : "15px",
            paddingRight: isTabletOrMobile ? "0" : "15px",
            width: "56%",
        },
        cell1: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: isTabletOrMobile ? "0" : "15px",
            paddingRight: isTabletOrMobile ? "0" : "15px",
            width: isTabletOrMobile ? "135px" : "175px",
        },
    };

    // This function will handle the removal of the alert when clicked
    const handleClose = async (alertId, alertTypeId, deviceId) => {
        // Filter out the alert with the matching id
        const updatedAlerts = activeAlerts.filter(
            (alert) => alert.alert_id !== alertId
        );
        setActiveAlerts(updatedAlerts);
        const payload = {
            deviceId: deviceId,
            alertTypeId: alertTypeId,
        };
        await CrudService.updateNotificationStatus(payload);
    };

    const checkAllNotification = (alerts) => {
        let isAllNotification = false;
        alerts.forEach((alert) => {
            if (alert?.AlertType?.category != "notice") {
                isAllNotification = true;
                return;
            }
        });
        return isAllNotification;
    };

    const openModalFn = (type) => {
        if (type == "device") {
            setGps({
                latitude: paramValue?.latitude,
                longitude: paramValue?.longitude,
            });
        } else if (type == "item") {
            setGps({
                latitude: deviceSetupFields?.latitude,
                longitude: deviceSetupFields?.longitude,
                edit: true,
            });
        } else if (type == "itemButton") {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
                edit: true,
            });
        } else {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
            });
        }
        setOpenModal(true);
    };

    const cond = [null, undefined];

    const formatValue = (value, format, display_ui) => {
        let ans = value;
        if (typeof value === 'boolean') {
            ans = value ? 'True' : 'False'
        }

        if (display_ui === 'badge') {
            return <Badge
                color={gpsStatusBadgeColor(ans)}
                variant={'standard'}
                badgeContent={ans}
                style={{ marginLeft: "30px" }}
            ></Badge>
        }

        if (display_ui === 'duration') {
            let dur = moment.duration({ from: ans, to: new Date() });
            return dur.humanize()
        }

        return ans + format
    }

    const formatValueForSignal = (value) => {
        let ans = value;
        if (typeof value === 'boolean') {
            ans = value ? 'On' : 'Off'
        }

        return ans
    }

    const RenderTH = ({ value }) => {
        return (
            <th scope="row" className="text-sm-end text-start" style={styles.cell1}>
                <MDTypography fontSize={1}>
                    <span style={{ fontWeight: "700" }}>{value}:</span>
                </MDTypography>
            </th>
        );
    };

    const RenderTD = ({ value, style = null, fun = () => { } }) => {
        return (
            <td style={style ?? styles.cell} onClick={fun}>
                <MDTypography fontSize={1}>{value}</MDTypography>
            </td>
        );
    };

    const RenderTR = ({ th, td, tdStyle: customTdStyle, tdFun }) => {
        const mergedTdStyle = {
            ...customTdStyle,
            padding: "0px 15px",
        };

        return (
            <>
                {!["", null, undefined].includes(td) && (
                    <>
                        <RenderTH value={th} />
                        <RenderTD value={td} style={mergedTdStyle} fun={tdFun} />
                    </>
                )}
            </>
        );
    };

    const RenderTableRowData = ({ label, value, unit, renderType }) => {
        return (
            <TableRow>
                <TableCell style={styles.cell}>
                    <MDTypography fontSize={1}>
                        <span style={{ fontWeight: "700" }}>{label}:</span>
                    </MDTypography>
                </TableCell>
                <TableCell style={styles.cell}>
                    <MDTypography fontSize={1}>
                        {renderType === "text" ? (
                            typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? (
                                new Date(value).toLocaleDateString()
                            ) : isNaN(value) ? (
                                value
                            ) : (
                                `${Math.trunc(value)}${unit ? unit : ""}`
                            )
                        ) : renderType === "icon" ? (
                            <Box display="flex" alignItems="center">
                                <span>{value}</span>
                                &nbsp;
                                {renderIcon(label, value)}
                            </Box>
                        ) : (
                            <Box display="flex" alignItems="center">
                                <span>{value}</span>
                                {renderIcon(label, value)}
                            </Box>
                        )}
                    </MDTypography>
                </TableCell>
            </TableRow>
        );
    };

    const TableSection = ({ title, rowData }) => (
        <Box sx={{ marginBottom: 2 }}>
            <MDTypography fontSize={1}>
                <span style={{ fontWeight: "700" }}>{title}</span>
            </MDTypography>
            <Table
                style={{
                    ...styles.table,
                    marginTop: "5px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
            >
                <TableBody>
                    {rowData.map((row, idx) => (
                        <RenderTableRowData key={idx} {...row} />
                    ))}
                </TableBody>
            </Table>
        </Box>
    );

    const clickExportHandler = async (id) => {
        try {
            const exportUrl = `${process.env.REACT_APP_API_URL}/modules/export_excel/${id}`;
            window.open(exportUrl, '_blank');
        } catch (error) {
            console.error('clickExportHandler error', error)
        }
    }

    const clickRouteViewHandler = async (data) => {
        try {
            setHighlightRouteData([{ ...data, selected: true }])
            uiPage.current?.scrollIntoView({ behavior: "smooth" });
        } catch (error) {
            console.error('clickRouteViewHandler error', error)
        }
    }

    const openLogs = (data, type) => {
        if (data && type) {
            setRawDataValue(data[type] ?? '')
            setJsonTree(true)
        }
    }

    const clickInfoHandler = (data) => {
        if (data.start_group || data.end_group) {
            setSelectedRouteGroup({
                start: data?.start_group,
                end: data?.end_group,
                route_id: data.route_id
            })
        } else {
            window.alert('No data')
        }
    }

    const closeHighlightRoute = () => setHighlightRouteData([])

    const DisplayGeofenceLocation = ({ parameter_name }) => {

        if (parameter_name !== 'moment_status_duration') {
            return
        }
        if (!geofence) {
            return
        }

        return (
            <TableRow key={'geofenceName'}>
                <TableCell
                    style={styles.cell}
                >
                    <MDTypography fontSize={1}>
                        <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                            {geofenceIcon ? <i className={geofenceIcon?.class_name}></i> : ''}
                            Geofence:
                        </strong>
                    </MDTypography>
                </TableCell>
                <TableCell
                    style={styles.cell}
                    title={geofence?.geofence_id}
                >
                    <MDTypography fontSize={1} style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                        {geofence?.name} <div style={{ width: '15px', height: '15px', borderRadius: '50%', display: 'inline-block', backgroundColor: geofence?.color }} title={geofence?.color}></div>
                    </MDTypography>

                </TableCell>
            </TableRow>
        )
    }

    return (
        <div style={{ width: '100%', height: '100vh', padding: '0 1rem' }}>
            <DashboardNavbar title={navbarTitle} titleIcon={titleIcon} showBreadCrumbs={false} />

            <MDBox mt={0} mb={9} ref={uiPage}>
                <Grid justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={0} mb={0} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    {titleIcon ? <i className={titleIcon} style={{ fontSize: "24px" }}></i> : ''} {device?.attributes?.name}{" "}
                                    {activeAlerts.length != 0 &&
                                        checkAllNotification(activeAlerts) ? (
                                        <i
                                            className="fas fa-triangle-exclamation"
                                            style={{ fontSize: "24px", color: "#d32f2f" }}
                                        ></i>
                                    ) : (
                                        ""
                                    )}
                                </MDTypography>
                                {activeAlerts.map((alert) => (
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid ${
                                                // alert?.AlertType?.alert_type_id === 11 ||
                                                // alert?.AlertType?.alert_type_id === 12
                                                alert?.AlertType?.category == "notice"
                                                    ? "green"
                                                    : "#d32f2f"
                                                }`,
                                            alignItems: "center",
                                            backgroundColor:
                                                alert?.AlertType?.category == "notice"
                                                    ? "#d1ffd6"
                                                    : "#ffcccb",
                                        }}
                                    >
                                        {/* Close button */}
                                        {alert?.AlertType?.category == "notice" && (
                                            <button
                                                style={{
                                                    position: "absolute",
                                                    top: "5px",
                                                    right: "5px",
                                                    background: "transparent",
                                                    border: "none",
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "black",
                                                }}
                                                onClick={() =>
                                                    handleClose(
                                                        alert?.alert_id,
                                                        alert?.alert_type_id,
                                                        alert?.device_id
                                                    )
                                                } // Replace with your close function
                                            >
                                                &times;
                                            </button>
                                        )}
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color:
                                                    alert?.AlertType?.category == "notice"
                                                        ? "green"
                                                        : "#d32f2f",
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <i
                                                className={alert?.AlertType?.Icon?.class_name}
                                                style={{
                                                    marginRight: "5px",
                                                    fontSize: "16px",
                                                    color:
                                                        alert?.AlertType?.category == "notice"
                                                            ? "green"
                                                            : "#d32f2f",
                                                }}
                                            ></i>{" "}
                                            {alert?.AlertType?.type_name} -{" "}
                                            {alert?.AlertType?.description} &middot;{" "}
                                            {moment(alert?.created_at).format(
                                                "MMMM Do YYYY, h:mm:ss A"
                                            )}
                                        </MDTypography>
                                    </div>
                                ))}
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    <MDBox mb={3}>
                                        {
                                            (gpsData.latitude != null && gpsData.longitude != null) ?
                                                <AssetTrackerMap latitude={gpsData.latitude} longitude={gpsData.longitude} heading={gpsData.heading} mapIcon={mapIcon} ignoreHeading={ignoreHeading} gpsStatus={gpsStatus} icons={icons} routeData={highlightRouteData.length > 0 ? highlightRouteData : routeData} closeHighlightRoute={closeHighlightRoute} activeAlerts={activeAlerts} geofence={geofence} paramValue={paramValue} />
                                                // <AssetTrackerMap latitude={gpsData.latitude} longitude={gpsData.longitude} heading={gpsData.heading} mapIcon={mapIcon} gpsStatus={gpsStatus} deviceName={device?.attributes?.name} deviceId={deviceId} icons={icons} routeData={highlightRouteData.length > 0 ? highlightRouteData : routeData} closeHighlightRoute={closeHighlightRoute} activeAlerts={activeAlerts} />
                                                : <></>
                                        }
                                    </MDBox>
                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Device Information",
                                                    icon: "fas fa-info-circle",
                                                },
                                                { title: "Current Data", icon: "fas fa-chart-line" },
                                                { title: "Monitor", icon: "fas fa-tachometer-alt" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index}>
                                                    <Card style={cardStyle(index)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index)}
                                                        />
                                                        {expandedIndexArray[index] && (
                                                            <CardContent
                                                                style={
                                                                    isTabletOrMobile
                                                                        ? { padding: "16px", flex: 1 }
                                                                        : { flex: 1 }
                                                                }
                                                            >
                                                                {index === 0 && (
                                                                    <>

                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {name?.text}
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes?.DeviceType
                                                                                                        ?.type_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Brand:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceBrand?.brand_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Model:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceModel?.model_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Item?.ItemType?.type_name ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Item Type:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Item
                                                                                                                ?.ItemType?.type_name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Address?.address_id ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>
                                                                                                            Entity Address Id:
                                                                                                        </strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.address_id
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.name ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Item Name:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Item?.name ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Item Type:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Item
                                                                                                                ?.name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Address ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Address Name:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Address ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Address:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {[
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.street_address1,
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.street_address2,
                                                                                                            [
                                                                                                                device?.attributes
                                                                                                                    ?.EntityAddressItem
                                                                                                                    ?.Address?.city,
                                                                                                                device?.attributes
                                                                                                                    ?.EntityAddressItem
                                                                                                                    ?.Address?.state,
                                                                                                                device?.attributes
                                                                                                                    ?.EntityAddressItem
                                                                                                                    ?.Address?.postal_code,
                                                                                                            ]
                                                                                                                .filter(Boolean)
                                                                                                                .join(", "),
                                                                                                        ]
                                                                                                            .filter(Boolean)
                                                                                                            .join(", ")}
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Status / Mode:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.StatusOption?.StatusType
                                                                                                        ?.status_name
                                                                                                } / {
                                                                                                    device?.attributes?.DeviceMode?.mode_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    {deviceSetupFields?.latitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Latitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.latitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                    {deviceSetupFields?.longitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Longitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.longitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {loader && <StackSkeleton />}

                                                                        <Table
                                                                            style={{
                                                                                ...styles.table,
                                                                                marginTop: "5px",
                                                                                boxShadow:
                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                            }}
                                                                        >
                                                                            <TableBody>
                                                                                {(!loader && parameters.length && paramValue) ? (
                                                                                    parameters.map((e) => {
                                                                                        if (show_current_data.includes(e.parameter_name) && !cond.includes(paramValue[e.parameter_name])) {
                                                                                            return (
                                                                                                <React.Fragment key={e.parameter_name}>
                                                                                                    <TableRow key={e.parameter_name}>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                            title={e.tooltip}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                    {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                                    {e.label}:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {formatValue(paramValue[`convert_${e.parameter_name}`] ?? paramValue[e.parameter_name], e.format ?? '', e.display_ui ?? '')}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                    <DisplayGeofenceLocation parameter_name={e.parameter_name} />
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        }
                                                                                        return <></>;
                                                                                    })
                                                                                ) : ''}
                                                                                {(!loader && parameters.length && trackingCounter) ? (
                                                                                    parameters.map((e) => {
                                                                                        if (counter_data.includes(e.parameter_name) && !cond.includes(trackingCounter[e.parameter_name])) {
                                                                                            return (
                                                                                                <React.Fragment key={e.parameter_name}>
                                                                                                    <TableRow key={e.parameter_name}>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                            title={e.tooltip}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                    {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                                    {e.label}:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {e.parameter_name == 'current_mileage' ? formatValue(trackingCounter[e.parameter_name], e.format ?? '', e.display_ui ?? '') : formatDuration(trackingCounter[e.parameter_name])}
                                                                                                            </MDTypography>

                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                    <DisplayGeofenceLocation parameter_name={e.parameter_name} />
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        }
                                                                                        return <></>;
                                                                                    })
                                                                                ) : ''}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                        {loader && <StackSkeleton />}
                                                                        {!loader && (
                                                                            <MDBox>
                                                                                <table className="table table-borderless">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <RenderTR
                                                                                                th={"Name"}
                                                                                                td={device?.monitor}
                                                                                            />
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_status
                                                                                                ?.StatusType?.status_name && (
                                                                                                    <RenderTR
                                                                                                        th={"Status"}
                                                                                                        td={
                                                                                                            <Badge
                                                                                                                color={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail
                                                                                                                        ?.color || "primary"
                                                                                                                }
                                                                                                                variant={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail?.variant
                                                                                                                }
                                                                                                                badgeContent={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.StatusType
                                                                                                                        ?.status_name
                                                                                                                }
                                                                                                                style={{
                                                                                                                    marginLeft: "30px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        }
                                                                                                    />
                                                                                                )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_frequency && (
                                                                                                <RenderTR
                                                                                                    th={"Frequency"}
                                                                                                    td={`${device?.monitor_frequency ??
                                                                                                        ""
                                                                                                        } ${device?.monitor_time_unit ??
                                                                                                        ""
                                                                                                        }`}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_last_updated && (
                                                                                                <RenderTR
                                                                                                    th={"Last Updated"}
                                                                                                    td={moment(
                                                                                                        device?.monitor_last_updated
                                                                                                    ).format(
                                                                                                        "MMMM Do YYYY, h:mm:ss a"
                                                                                                    )}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>

                                                                                {device?.deviceThresholds.map(
                                                                                    (threshold, thresholdIndex) => (
                                                                                        <Table
                                                                                            key={thresholdIndex + 3}
                                                                                            style={{
                                                                                                ...styles.table,
                                                                                                marginTop: "5px",
                                                                                                boxShadow:
                                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                            }}
                                                                                        >
                                                                                            <TableBody>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Alert Type:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.AlertType
                                                                                                                    ?.type_name
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Parameter
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.DeviceParameter
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Comparison Operator:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.ComparisonOperator
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Threshold Comparison
                                                                                                                Value:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.threshold_value
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    )
                                                                                )}
                                                                            </MDBox>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                { title: "Transmission", icon: "fas fa-signal" },
                                                { title: "Device Signal", icon: "fas fa-chart-diagram" },
                                                { title: "Providers", icon: "fas fa-truck" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 3}>
                                                    <Card style={cardStyle(index + 3)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 3)}
                                                        />
                                                        {expandedIndexArray[index + 3] && (
                                                            <CardContent style={{ flex: 1 }}>
                                                                {index === 0 && (
                                                                    <>
                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    {!loader && (
                                                                                        <>
                                                                                            {(!loader && parameters.length) ? (
                                                                                                parameters.map((e) => (
                                                                                                    !cond.includes(paramValue[e.parameter_name]) && show_transmission_data.includes(e.parameter_name) &&
                                                                                                    <TableRow key={e.parameter_name}>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                            title={e.tooltip}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                    {e.Icon ? <i className={`fa-solid fa-${e.Icon.icon_name}`}></i> : ''}
                                                                                                                    {e.label}:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {formatValue(paramValue[e.parameter_name], e.format ?? '', e.display_ui ?? '')}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                ))
                                                                                            ) : ''}
                                                                                            {(reporting) ? (
                                                                                                <>
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong>Reported: </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {moment(+`${reporting}000`).format("MMM Do YYYY, h:mm A")}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong>Last Updated: </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {moment(+`${reporting}000`).fromNow()}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                </>
                                                                                            ) : <> </>}
                                                                                        </>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {loader && <StackSkeleton />}

                                                                        <Table
                                                                            style={{
                                                                                ...styles.table,
                                                                                marginTop: "5px",
                                                                                boxShadow:
                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                            }}
                                                                        >
                                                                            <TableBody>
                                                                                {(!loader && parameters.length) ? (
                                                                                    parameters.map((e) => (
                                                                                        !cond.includes(paramValue[e.parameter_name]) && show_device_signal_data.includes(e.parameter_name) &&
                                                                                        <>
                                                                                            {
                                                                                                e.parameter_name == 'din_1' ? <h5 style={deviceSignalSubHeaderStyle}>Digital Input</h5> : ''
                                                                                            }
                                                                                            {
                                                                                                e.parameter_name == 'dout_1' ? <h5 style={deviceSignalSubHeaderStyle}>Digital Output</h5> : ''
                                                                                            }
                                                                                            {
                                                                                                e.parameter_name == 'ain_0' ? <h5 style={deviceSignalSubHeaderStyle}>Analog Input</h5> : ''
                                                                                            }
                                                                                            <TableRow key={e.parameter_name}>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                    title={e.tooltip}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                            {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                            {e.label}:
                                                                                                        </strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            typeof paramValue[e.parameter_name] == 'boolean' ?
                                                                                                                <Badge
                                                                                                                    color={paramValue[e.parameter_name] ? 'success' : 'error'}
                                                                                                                    variant={'standard'}
                                                                                                                    badgeContent={formatValueForSignal(paramValue[e.parameter_name])}
                                                                                                                    style={{ marginLeft: "30px" }}
                                                                                                                ></Badge>
                                                                                                                :
                                                                                                                paramValue[e.parameter_name]
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        </>
                                                                                    ))
                                                                                ) : ''}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </>
                                                                )}

                                                                {index === 2 && (
                                                                    <>
                                                                        <MDBox>
                                                                            <Grid
                                                                                container
                                                                                justifyContent="space-between"
                                                                            >
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6">
                                                                                        Provider
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6" mr={3}>
                                                                                        Share
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                            </Grid>
                                                                            {!loader ? (
                                                                                <>
                                                                                    {device?.entityAddressItemProviders.map(
                                                                                        (provider) => (
                                                                                            <MDBox
                                                                                                key={provider?.association_id}
                                                                                                sx={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent:
                                                                                                        "space-between",
                                                                                                    width: "100%",
                                                                                                }}
                                                                                            >
                                                                                                <MDBox
                                                                                                    sx={{
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                    }}
                                                                                                >
                                                                                                    <Avatar
                                                                                                        src={
                                                                                                            provider?.Provider
                                                                                                                ?.logo_url
                                                                                                        }
                                                                                                        alt={
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                        sx={{
                                                                                                            width: 60,
                                                                                                            height: 60,
                                                                                                        }}
                                                                                                    />
                                                                                                    <MDTypography ml={2}>
                                                                                                        {
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </MDBox>
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Contact Detail",
                                                    icon: "fas fa-address-book",
                                                },
                                                {
                                                    title: "Device Setup",
                                                    icon: "fas fa-wrench",
                                                },
                                                { title: "Actions", icon: "fas fa-cogs" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 6}>
                                                    <Card style={cardStyle(index + 6)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 6)}
                                                        />
                                                        {expandedIndexArray[index + 6] && (
                                                            <CardContent
                                                                style={{
                                                                    flex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                }}
                                                            >
                                                                {index === 0 && (
                                                                    <>
                                                                        {!loader ? (
                                                                            <>
                                                                                {device &&
                                                                                    device.contacts &&
                                                                                    device.contacts.map(
                                                                                        (contact, contactindex) => (
                                                                                            <MDBox key={contactindex + 6}>
                                                                                                <Table
                                                                                                    style={{
                                                                                                        ...styles.table,
                                                                                                        marginTop: "5px",
                                                                                                        boxShadow:
                                                                                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                                    }}
                                                                                                >
                                                                                                    <TableBody>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Contact Name:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {`${contact?.Contact?.first_name} ${contact?.Contact?.last_name}`}
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Access Type:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.access_type?.toUpperCase()
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Status:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.Contact
                                                                                                                            ?.StatusOption
                                                                                                                            ?.StatusType
                                                                                                                            ?.status_name
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        {contact?.Contact
                                                                                                            ?.ContactAddresses &&
                                                                                                            contact?.Contact?.ContactAddresses.map(
                                                                                                                (address, subindex) => (
                                                                                                                    <TableRow
                                                                                                                        key={subindex + 6}
                                                                                                                    >
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                <span
                                                                                                                                    style={{
                                                                                                                                        fontWeight:
                                                                                                                                            "700",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {" "}
                                                                                                                                    {
                                                                                                                                        address
                                                                                                                                            ?.ContactAddressType
                                                                                                                                            ?.type_name
                                                                                                                                    }
                                                                                                                                    :{" "}
                                                                                                                                </span>
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    address?.contact_address
                                                                                                                                }
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                    </TableRow>
                                                                                                                )
                                                                                                            )}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                            </>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        <MDBox>
                                                                            {!loader ? (
                                                                                <Table
                                                                                    style={{
                                                                                        ...styles.table,
                                                                                        marginTop: "5px",
                                                                                        boxShadow:
                                                                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                    }}
                                                                                >
                                                                                    <TableBody>
                                                                                        {/* Render Device Setup Fields */}
                                                                                        {[
                                                                                            {
                                                                                                label: "External ID",
                                                                                                value:
                                                                                                    device?.external_device_id,
                                                                                            },
                                                                                            {
                                                                                                label: "Reference ID",
                                                                                                value: paramValue?.id,
                                                                                            },
                                                                                            {
                                                                                                label: "Depth",
                                                                                                value: deviceSetupFields?.depth,
                                                                                            },
                                                                                            {
                                                                                                label: "Shape",
                                                                                                value: deviceSetupFields?.shape,
                                                                                            },
                                                                                            {
                                                                                                label: "Width",
                                                                                                value: deviceSetupFields?.width,
                                                                                            },
                                                                                            {
                                                                                                label: "Length",
                                                                                                value:
                                                                                                    deviceSetupFields?.length,
                                                                                            },
                                                                                        ].map(
                                                                                            (field, index) =>
                                                                                                field.value && (
                                                                                                    <TableRow
                                                                                                        key={`setup-${index}`}
                                                                                                    >
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                <span
                                                                                                                    style={{
                                                                                                                        fontWeight: "700",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {field.label}:
                                                                                                                </span>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                {field.value}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                )
                                                                                        )}

                                                                                        {/* Render Device Identifier Values */}
                                                                                        {device.attributes?.DeviceIdentifierValues?.map(
                                                                                            (e, i) => (
                                                                                                <TableRow
                                                                                                    key={`identifier-${i}`}
                                                                                                >
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    e.DeviceIdentifierType
                                                                                                                        .identifier_type_name
                                                                                                                }
                                                                                                                :
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {e.value}
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )
                                                                                        )}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <Modal open={openModal} onClose={() => setOpenModal(false)}>
                                        <MDBox tabIndex={-1}>
                                            <GoogleMapComponent
                                                lat={gps.latitude}
                                                lng={gps.longitude}
                                            />
                                        </MDBox>
                                    </Modal>
                                    <Grid item xs={12} sm={8} lg={4}>
                                        <Tabs
                                            value={selectedTab}
                                            orientation={tabsOrientation}
                                            onChange={handleTabChange}
                                            aria-label="Tabs"
                                            sx={{ display: "flex" }}
                                        >
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-file-alt"
                                                            style={{ marginRight: "2px" }}
                                                        ></i>
                                                        Logs
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-exclamation-triangle"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Alerts
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-exclamation-triangle"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Routes
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fa-solid fa-clock"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Events
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-code-branch"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Rules
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1.5", p: "2" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "0px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-tools"
                                                            style={{ marginRight: "0px" }}
                                                        ></i>
                                                        <Typography
                                                            sx={{ fontSize: { xs: "0.825rem", sm: "1rem" } }}
                                                        >
                                                            Service Request
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                        </Tabs>
                                    </Grid>

                                    {selectedTab === 0 && (
                                        <DataTable
                                            table={dataTableData}
                                            canSearch={true}
                                            loader={loaderT}
                                        />
                                    )}
                                    {selectedTab === 1 && (
                                        <>
                                            <MDBox pt={6} pb={3}>
                                                <MDBox mb={3}>
                                                    <CollapsibleTable
                                                        width="100%"
                                                        data={alertTableData}
                                                        columns={alertColumns}
                                                    />
                                                </MDBox>
                                            </MDBox>
                                        </>
                                    )}
                                    {selectedTab === 2 && (
                                        <>
                                            <RouteModal selectedRouteGroup={selectedRouteGroup} setSelectedRouteGroup={setSelectedRouteGroup} />
                                            <RouteCollapsibleTabTable
                                                width="100%"
                                                data={getRouteTable(routeAllData)}
                                                columns={routeColumns}
                                                subColumns={routeSubColumns}
                                                clickInfoHandler={clickInfoHandler}
                                                clickViewHandler={clickRouteViewHandler}
                                                clickExportHandler={clickExportHandler}
                                                openLogs={openLogs}
                                                page={page}
                                                setPage={setPage}
                                                rowsPerPage={rowsPerPage}
                                                setRowsPerPage={setRowsPerPage}
                                                count={countRef.current}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 3 && (
                                        <>
                                            <DataTable
                                                table={eventdataTableData}
                                                canSearch={true}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 4 && (
                                        <>
                                            <DataTable
                                                table={alertRuledataTableData}
                                                canSearch={true}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 5 && (
                                        <MDBox sx={{ marginTop: "20px" }}>
                                            <ServiceRequestDataTable
                                                table={serviceRequestdataTableData}
                                                canSearch={true}
                                            />
                                        </MDBox>
                                    )}

                                    <MDBox
                                        ml="auto"
                                        mt={4}
                                        mb={2}
                                        display="flex"
                                        justifyContent="flex-end"
                                    >
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/devices", {
                                                        state: {
                                                            value: false,
                                                            text: "",
                                                        },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <JsonTree open={openJsonTree} onClose={() => setJsonTree(false)} data={rawDataValue} />
            <Footer />
        </div>
    );
};

export default PublicAssetTracker;
